import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import SuperSearchList from "../../shared/SuperSearch/SuperSearchList";
import { enumUtil } from "../../../utils/Enum";
import { ServerRequestProtected } from "../../../utils/ServerDataRequest";
import Loader from "../../shared/Loader/Loader";
import isNull from "../../../utils/NullChecking";
import { useSelector } from "react-redux";
import { ServiceTypeCode } from "../../../utils/Constants";
import NotificationHandler from "../../../utils/NotificationHandler";
import EligiblityHistoryStatus from "../../Billing/Realtime/RealtimeDetails/Eligibility History/History/EligiblityHistoryStatus";
import DatePicker from "../../General/DatePicker";

const EligibilityBulk = (props) => {
    const API_Eligibility = enumUtil.controller.Eligibility;
    const DropdownData = useSelector((state) => state.GeneralDropDownsReducer);

    const { isOpenBulkEligibility, CloseBulkEligibity, SelectID, type } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [loadingRows, setLoadingRows] = useState({});
    const [edit, setEdit] = useState(false);
    const [actionColumn, setActionColumn] = useState(false);
    const [bulkEligibilityData, setBulkEligibilityData] = useState([]);
    const [eligibilityStatuses, setEligibilityStatuses] = useState({});
    const [patientEligibiltyID, setPatientEligibiltyID] = useState([]);

    const [EligibilityPopup, setEligibilityPopup] = useState(false);

    const [showResponse, setShowResponse] = useState(false)

    const id = ['1', '2', '3', '4']

    // Load initial data
    const LoadData = () => {
        setIsLoading(true);
        ServerRequestProtected(API_Eligibility + "/GetInstantEligibilityData", "post", {
            TableName: enumUtil.enumAPITableName.BulkEligibility,
            SearchCriteria: { IDs: SelectID, Peram: type ? type : "Patient" },
        })
            .then((response) => {
                const updatedData = response.map((item) => ({
                    ...item,
                    ServiceTypeCode: "30 - Health Benefit Plan Coverage",
                    ServiceTypeCodeID: "30",
                }));
                setBulkEligibilityData(updatedData);
                setIsLoading(false);
            })
            .catch(() => setIsLoading(false));
    };

    useEffect(() => {
        LoadData();
    }, []);

    const handleChangeInsurance = (e, index) => {
        const { value } = e.target;
        const copy = [...bulkEligibilityData];
        copy[index]["Insurance"] = value;
        setBulkEligibilityData(copy);
    };
    const handleCalendarChange = (date, index, type) => {
        var FormatedDate = date
        let modal = [...bulkEligibilityData];
        modal[index][type] = FormatedDate
        setBulkEligibilityData(modal)
    }

    const handleSelectedDataInsurance = (selectedData, index, type) => {
        if (!isNull(selectedData)) {
            const copy = [...bulkEligibilityData];
            if (type === "Provider") {
                copy[index]["Provider"] = selectedData.display + "";
                copy[index]["ProviderID"] = selectedData.value + "";
            } else if (type === "ServiceTypeCode") {
                copy[index]["ServiceTypeCode"] = selectedData.display + "";
                copy[index]["ServiceTypeCodeID"] = selectedData.value + "";
            } else if (type === "Insurance") {
                copy[index]["Insurance"] = selectedData.display + "";
                copy[index]["InsuranceID"] = selectedData.value + "";
            }
            setBulkEligibilityData(copy);
        }
        return selectedData;
    };

    // Single row eligibility API call
    const handlePerformEligibility = async (rowIndex, item) => {
        setLoadingRows((prev) => ({ ...prev, [rowIndex]: true }));
        try {
            const formattedData = [
                {
                    InsurnaceID: item.InsuranceID + "",
                    PatientInsuranceID: item.PatientInsuranceID + "",
                    ProviderID: item.ProviderID + "",
                    ServiceTypeCode: item.ServiceTypeCodeID + "",
                    UsePracticeNPI: "true",
                    EligiblityDate: item.DOS + "",
                },
            ];
            const saveModal = { TableName: enumUtil.enumAPITableName.Generate270, data: formattedData };
            const response = await ServerRequestProtected(API_Eligibility + "/EligibilityRequest", "post", saveModal);

            setEligibilityStatuses((prev) => ({
                ...prev,
                [rowIndex]: response?.eligibilityStatus,
                [`${rowIndex}-reason`]: response.reason,
            }));
            // setPatientEligibiltyID((prev) => ({
            //     ...prev,
            //     [rowIndex]: response?.patientEligibiltyID+"" || "",
            // }));
            setPatientEligibiltyID((prev) => {
                const updated = [...prev]; // copy array
                updated[rowIndex] = response?.patientEligibiltyID?.toString();
                return updated;
            });

            setLoadingRows((prev) => ({ ...prev, [rowIndex]: false }));
        } catch (error) {
            setLoadingRows((prev) => ({ ...prev, [rowIndex]: false }));
            NotificationHandler(error.response?.data || "Error occurred", enumUtil.enumtoaster.error);
        }
    };

    console.log("patientEligibiltyID", patientEligibiltyID);
    // Bulk eligibility
    const handlePerformBulkEligibility = async () => {
        setActionColumn(true);
        for (let i = 0; i < bulkEligibilityData.length; i++) {
            await handlePerformEligibility(i, bulkEligibilityData[i]);
        }
        setShowResponse(true)
        setEdit(false)
    };

    const [selectID, setSelectID] = useState(null);
    // Eye button function
    const handleViewEligibility = (rowIndex) => {
        setEligibilityPopup(true)
        setSelectID(patientEligibiltyID[rowIndex])
        // console.log("View Eligibility Row:", rowInde);
        // Yaha apna modal ya aur logic add kar sakte ho
    };

    // Download button function
    const handleDownloadEligibility = (rowIndex, item) => {
        console.log("Download Eligibility Row:", rowIndex, item);
        // Yaha apna download logic add kar sakte ho
    };
    const handleOpenEligibityHistory = () => {
        setEligibilityPopup(true)
    }
    const CloseEligibilityPopup = () => {
        // CloseEligibility()
        setEligibilityPopup(false)
    }

    return (
        <>
            {isLoading && <Loader />}

            <Modal
                show={isOpenBulkEligibility}
                onHide={CloseBulkEligibity}
                backdrop="static"
                keyboard={false}
                centered
                dialogClassName="hk-modal-v1 table-default-design ar-Perform-Bulk-Eligibility"
            >
                <Modal.Body>
                    <div className="d-flex align-items-center justify-content-between mb-12">
                        <p className="heading dark-clr fs-14">Perform Bulk Eligibility</p>
                        <i className="icon-x-cros fs-20 dark-clr" onClick={CloseBulkEligibity}></i>
                    </div>

                    <div className="hk-expand-table overflow-auto BorderLess-table">
                        <table className="w-100">
                            <thead>
                                <tr>
                                    <th>Patient</th>
                                    <th>DOS</th>
                                    <th>Insurance</th>
                                    <th>Subscriber ID</th>
                                    <th>Provider</th>
                                    <th>Service Type Code</th>
                                    <th className="w-0px min-w-unset">
                                        {showResponse ? null : (
                                            <div className="d-flex justify-content-center align-items-center gap-01">
                                                {edit ? (
                                                    <>
                                                        {/* <i className="icon-check orange-light fs-18 lh-12 fw-bolder"></i> */}
                                                        <i className="icon-x-cros gray-clr fs-18 lh-12 fw-bolder" onClick={() => setEdit(false)}></i>
                                                    </>
                                                ) : (
                                                    <i className="icon-Icon-material-edit fs-11 ar-light-color" onClick={() => setEdit(true)}></i>
                                                )}
                                            </div>
                                        )}
                                    </th>
                                    {actionColumn && (
                                        <>
                                            <th className="w-0px min-w-unset">Status</th>
                                            <th className="w-0px min-w-unset">Action</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {bulkEligibilityData.length > 0 ? (
                                    bulkEligibilityData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.Patient}</td>
                                            {edit ? (
                                                <td>
                                                    <DatePicker
                                                        id="DOS"
                                                        value={item.DOS}
                                                        handleCalendarChangefunc={date => handleCalendarChange(date, index, 'DOS')}
                                                    />
                                                </td>
                                            ) : (
                                                <td>{item.DOS}</td>
                                            )}
                                            {edit ? (
                                                <td>
                                                    <SuperSearchList
                                                        type="client"
                                                        id="Insurance"
                                                        name="Insurance"
                                                        searchValue={item?.Insurance}
                                                        data={item.Children.length > 0 ? item.Children : []}
                                                        onChange={handleChangeInsurance}
                                                        getSelectedData={(singleRow) => handleSelectedDataInsurance(singleRow, index, "Insurance")}
                                                        icon={"Simple"}
                                                        ScrollOutside={true}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </td>
                                            ) : (
                                                <td>{item.Insurance}</td>
                                            )}
                                            <td>{item.SubscriberID}</td>

                                            {edit ? (
                                                <td>
                                                    <SuperSearchList
                                                        type="client"
                                                        id="ProviderID"
                                                        name="ProviderID"
                                                        searchValue={item?.Provider}
                                                        data={DropdownData?.Provider}
                                                        onChange={handleChangeInsurance}
                                                        getSelectedData={(singleRow) => handleSelectedDataInsurance(singleRow, index, "Provider")}
                                                        icon={"Simple"}
                                                        ScrollOutside={true}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </td>
                                            ) : (
                                                <td>{item.Provider}</td>
                                            )}
                                            {edit ? (
                                                <td>
                                                    <SuperSearchList
                                                        type="client"
                                                        id="ServiceTypeCode"
                                                        name="ServiceTypeCode"
                                                        searchValue={item?.ServiceTypeCode}
                                                        data={ServiceTypeCode}
                                                        onChange={handleChangeInsurance}
                                                        getSelectedData={(singleRow) => handleSelectedDataInsurance(singleRow, index, "ServiceTypeCode")}
                                                        icon={"Simple"}
                                                        ScrollOutside={true}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </td>
                                            ) : (
                                                <td>{item.ServiceTypeCode}</td>
                                            )}
                                            <td></td>

                                            {actionColumn && (
                                                <>
                                                    <td>
                                                        {loadingRows[index] ? (
                                                            <div className="ar-small-loader last_loader justify-content-center">
                                                                <div className="circle circle1"></div>
                                                                <div className="circle circle2"></div>
                                                            </div>
                                                        ) : (
                                                            <div className="app_tooltip bottom grossary description claimStatus">
                                                                <p className={`pill ${eligibilityStatuses[index] === "Active" ? "Paid" : "Cancelled"}`}>
                                                                    {eligibilityStatuses[index] || ""}
                                                                    {!isNull(eligibilityStatuses[index]) && eligibilityStatuses[index] === 'Rejected' ? <p className="tool_tip">
                                                                        <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={eligibilityStatuses[`${index}-reason`]}> {eligibilityStatuses[`${index}-reason`]}</span>
                                                                    </p> : null}
                                                                </p>
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <button className="border-0 bg-transparent no-width rounded eye app_tooltip left p-0" onClick={() => handleViewEligibility(index)}>
                                                                <i className="icon-Icon-awesome-eye fs-10"></i>
                                                            </button>
                                                            {/* <button className="border-0 no-width Sdownload-btn" onClick={() => handleDownloadEligibility(index, item)}>
                                                                <i className="icon-download-svgrepo-com fs-16"></i>
                                                            </button> */}
                                                        </div>
                                                    </td>
                                                </>
                                            )}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center">
                                            No Data Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <Modal show={EligibilityPopup} onHide={CloseEligibilityPopup} backdrop="static" keyboard={false} centered className='app-modal modal modal-dialog-centered modal-lg add_new_eligibility hk-modal-v1' unmountOnExit>
                        <Modal.Body className='pb-4'>
                            <div className='d-flex justify-content-end' onClick={CloseEligibilityPopup}>
                                <button className="btn-icon-transparent">
                                    <i className="icon-Icon-metro-cross"></i>
                                </button>
                            </div>
                            <EligiblityHistoryStatus type={'BulkEligibity'} id={selectID} ListOfID={patientEligibiltyID} />
                        </Modal.Body>
                    </Modal>
                </Modal.Body>
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    {showResponse ? <button className="btn btn-outline px-10 h-100 dark-clr" onClick={handleOpenEligibityHistory}>View Response</button> : null}
                    <button className={showResponse ? "btn btn-validate px-10 h-100 disable" : "btn btn-validate px-10 h-100"} onClick={handlePerformBulkEligibility}>
                        Perform Eligibility
                    </button>
                </div>
            </Modal>
        </>
    );
};

export default EligibilityBulk;
